import { Button, Grid, IconButton, Tooltip } from "@mui/material";
import { useEffect, useState } from "react";
import { useTranslation } from "react-i18next";
import PDatePicker from "../../components/pos/PDatePicker";
import PSelect from "../../components/pos/PSelect";
import PText from "../../components/pos/PText";
import DocumentUploadListView from "./DocumentUploadListView";

import AddIcon from "@mui/icons-material/Add";
import PCheck from "../../components/pos/PCheck";
import db from "../../db/db";
import { SyncUtils } from "../../utils/SyncUtils";
import AsyncSelect from "react-select/async";
import API from "../../utils/API";

export default function MPurchaseCrud(props) {
  const { t } = useTranslation();

  const [showDocumentUploadWindow, setshowDocumentUploadWindow] =
    useState(false);

  const [showImport, setShowImport] = useState(false);

  const [disableLoading, setDisableLoading] = useState(false);

  const [loading, setLoading] = useState(false);
  const [alertMessage, setAlertMessage] = useState("");
  const [alertFlag, setAlertFlag] = useState(false);

  const [productSetting, setProdoductSetting] = useState({});

  useEffect(() => {
    loadProductSetting();
  }, []);

  async function loadProductSetting() {
    let val = await db.setting.where("sKey").equals("product").toArray();
    let pSetting = JSON.parse(val[0].sValue);
    setProdoductSetting(pSetting);
  }

  function openAlert(flag) {
    setAlertFlag(flag);
  }

  const paymentModeOptions = [
    { name: "CREDIT", id: "CREDIT" },
    { name: "CASH", id: "CASH" },
  ];

  function handleAddFileClick() {
    setshowDocumentUploadWindow(true);
  }

  const handleCapture = ({ target }) => {
    if (target.files.length > 0) {
      setShowImport(true);
    } else {
      setShowImport(false);
    }
  };

  const formatOptionLabel = (option, { context }) => {
    //console.log(context);
    if (context === "menu") {
      return (
        <Grid container>
          <Grid item xs={3}>
            {option.value.unitType}
          </Grid>
          <Grid item xs={6}>
            {option.value.name}
          </Grid>
          <Grid item xs={3}>
            {option.value.lastCost}
          </Grid>
        </Grid>
      );
    }
    if (!option.label) return "";
    return option.label.name;
  };

  const getOptions = (inputValue, callback) => {
    getOptionsAsync(inputValue, callback);
  };

  async function getOptionsAsync(inputValue, callback) {
    let sort = [];
    sort.push({ id: "name", sortOrder: "ASC" });

    let search = { and: [], or: [] };
    search.and.push({
      op: "eq",
      key: "productType",
      value: "I",
    });

    search.or.push({
      op: "contains",
      key: "code",
      value: inputValue,
    });
    search.or.push({
      op: "contains",
      key: "name",
      value: inputValue,
    });
    search.or.push({
      op: "contains",
      key: "code",
      value: inputValue,
    });
    search.or.push({
      op: "contains",
      key: "sBarcodes",
      value: inputValue,
    });

    let { data } = await API.get(
      "/e_search/products?range=" +
        encodeURIComponent("[0,10]") +
        "&filter=" +
        encodeURIComponent(JSON.stringify(search)) +
        "&sort=" +
        encodeURIComponent(JSON.stringify(sort)) +
        "&showUnitTypes=true"
    );

    /*let arr = await SyncUtils.searchInCache(
      props.productCache,
      inputValue,
      100,
      [props.productType],
      true,
      true
    );*/
    //console.log("arr", arr);
    return callback(
      data.data.map(function (option, index) {
        return {
          value: option,
          label: option,
        };
      })
    );

    //return callback([]);
  }

  const translate = t;
  return (
    <div>
      <Grid
        container
        spacing={0.8}
        sx={{ marginTop: "10px", marginBottom: "6px" }}
      >
        <Grid item xs={props.mobile ? 6 : 12} sm={2}>
          <PText
            readOnly={true}
            value={props.refereneNumber}
            error={props.refereneNumberError}
            InputProps={{ readOnly: true }}
            onChange={(e) => props.setReferenenumber(e.target.value)}
            label={translate("Reference No")}
            InputLabelProps={{ shrink: true }}
          ></PText>
        </Grid>
        {(props.poType == "GRN" || props.poType == "GRV") && (
          <Grid item xs={props.mobile ? 6 : 12} sm={2}>
            <PText
              value={props.invoiceNumber}
              error={props.invoiceNumberError}
              onChange={(e) => props.setInvoiceNumber(e.target.value)}
              InputLabelProps={{ shrink: true }}
              label="Invoice No"
            ></PText>
          </Grid>
        )}
        <Grid item xs={6} sm={3}>
          <PSelect
            options={props.vendorOptions}
            value={props.vendor}
            errorMessage={props.vendorError}
            label={translate("Vendor")}
            onChange={(event, newValue) => {
              props.setVendorError("");
              props.setPaymentModeError("");
              props.setPaymentTermsError("");
              props.setVendor(newValue);
              if (newValue.bean && newValue.bean.paymentMode) {
                props.setPaymentMode({
                  name: newValue.bean.paymentMode,
                  id: newValue.bean.paymentMode,
                });
              }
              if (newValue.bean && newValue.bean.paymentTerms) {
                props.setPaymentTerms({
                  name: newValue.bean.paymentTerms,
                  id: newValue.bean.paymentTerms,
                });
              }
            }}
          ></PSelect>
        </Grid>
        {!props.mobile && (
          <Grid item xs={12} sm={2}>
            <PDatePicker
              defaultValue="2020-08-23"
              value={props.transactionDate}
              error={props.transactionDateError}
              onChange={(value) => {
                props.setTransactionDate(value);
              }}
              label={translate("Date")}
              InputLabelProps={{ shrink: true }}
            ></PDatePicker>
          </Grid>
        )}

        {!props.mobile && props.poType == "LPO" && (
          <Grid item xs={12} sm={2}>
            <PDatePicker
              defaultValue="2020-08-23"
              value={props.expectedDate}
              error={props.expectedDateError}
              onChange={(value) => {
                props.setExpectedDate(value);
              }}
              label={translate("Expected Date")}
              InputLabelProps={{ shrink: true }}
            ></PDatePicker>
          </Grid>
        )}

        {!props.mobile && (
          <Grid item xs={12} sm={1}>
            <PSelect
              options={paymentModeOptions}
              value={props.paymentMode}
              errorMessage={props.paymentModeError}
              onChange={(event, newValue) => {
                props.setPaymentMode(newValue);
                props.setPaymentModeError("");
              }}
              label={translate("Mode")}
              InputLabelProps={{ shrink: true }}
            ></PSelect>
          </Grid>
        )}
        {!props.mobile && (
          <Grid item xs={12} sm={1}>
            <PSelect
              options={props.paymentTermsOptions}
              value={props.paymentTerms}
              disabled={
                props.paymentMode == null || props.paymentMode.id == "CREDIT"
                  ? false
                  : true
              }
              errorMessage={props.paymentTermsError}
              onChange={(event, newValue) => {
                props.setPaymentTerms(newValue);
              }}
              label={translate("Terms")}
              InputLabelProps={{ shrink: true }}
            ></PSelect>
          </Grid>
        )}
        {!props.mobile && (
          <Grid item xs={12} sm={1}>
            <Button onClick={handleAddFileClick} color="primary">
              {translate("Document")}
            </Button>
          </Grid>
        )}

        <Grid item xs={6} sm={2}>
          <PSelect
            options={props.taxTypeOptions}
            value={props.taxType}
            label={translate("Tax")}
            onChange={(event, newValue) => {
              //props.setTaxType(newValue);
              props.handleWIthTaxChangeEvent(newValue);
            }}
          ></PSelect>
        </Grid>

        {!props.mobile && (props.poType == "GRN" || props.poType == "GRV") && (
          <Grid item xs={6} sm={2}>
            <PSelect
              label={translate("Cost Calculation")}
              options={props.costCalculationTypeOptions}
              value={props.costCalculationType}
              onChange={(event, newValue) => {
                props.handleCostCalculationTypeChangeEvent(newValue);
              }}
            ></PSelect>
          </Grid>
        )}
        {!props.mobile && (
          <Grid item xs={6} sm={3}>
            <PText
              value={props.note}
              error={props.noteError}
              onChange={(e) => props.setNote(e.target.value)}
              label={translate("Note")}
              InputLabelProps={{ shrink: true }}
            ></PText>
          </Grid>
        )}
        {!props.mobile && (
          <Grid item xs={6} sm={1.5} style={{ marginTop: "5px" }}>
            <PCheck
              onChange={(value) => props.setConsolidated(value)}
              checked={props.isConsolidated}
              label={translate("Consolidated")}
            ></PCheck>
          </Grid>
        )}

        {!props.mobile && props.poType != "GRV" && (
          <Grid item xs={12} sm={0.5}>
            <Tooltip title={"Create product"}>
              <IconButton
                aria-label="close"
                onClick={() => {
                  props.setOrigObject(null);
                  props.setShowProductCrud(true);
                }}
              >
                <AddIcon />
              </IconButton>
            </Tooltip>
          </Grid>
        )}
        {props.mobile && (
          <Grid xs={12} sx={{ marginTop: "5px", marginLeft: "5px" }}>
            <AsyncSelect
              formatOptionLabel={formatOptionLabel}
              components={{ formatOptionLabel }}
              menuPortalTarget={document.body}
              styles={{
                menuPortal: (base) => ({
                  ...base,
                  zIndex: 99999,
                }),
                marginRight: "10px",
              }}
              placeholder={translate("Product Lookup")}
              loadOptions={getOptions}
              onChange={props.productLookupChanged}
              onKeyDown={(e) => {
                e.stopPropagation();
                e.nativeEvent.stopImmediatePropagation();
              }}
              value={props.prodLookupValue}
            />
          </Grid>
        )}
      </Grid>
      {showDocumentUploadWindow && (
        <DocumentUploadListView
          showDocumentUploadWindow={showDocumentUploadWindow}
          setshowDocumentUploadWindow={setshowDocumentUploadWindow}
          filesList={props.filesList}
          setFilesList={props.setFilesList}
          showMessage={props.showMessage}
          setUploadFileId={props.setUploadFileId}
        ></DocumentUploadListView>
      )}
    </div>
  );
}
